import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';

import { FormSliderComponent } from './form-slider.component';

export const imports: NgModule['imports'] = [
  FlexLayoutModule,
  MatFormFieldModule,
  MatSliderModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormSliderComponent],
  imports: [...imports, CommonModule],
  exports: [FormSliderComponent],
})
export class FormSliderModule {}
